
<template>
  <div class="root">
    <div class="top">投诉记录</div>
    <div class="icon">
      <img src="../assets/images/tousujilu_03.png">
    </div>
    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index">
        <div class="left">
          <div class="text-1">{{ item.create_time }}</div>
          <div class="text-2">联系人：{{item.name}}</div>
          <div class="text-2">问题：{{item.desc}}</div>
        </div>
        <div class="right" v-if="item.result" @click="one=item,modal=true">
          已处理
        </div>
      </div>
    </div>
    <van-dialog v-model="modal" :showConfirmButton="false" width="6.5rem" :closeOnClickOverlay="true">
      <div class="modal-content">
        <div class="text-1">
          <span>问题：{{ one.desc }}</span>
        </div>
        <div class="text-2">
          <span>附件：</span>
          <img v-for="(item,index) in one.files" :key="index" :src="item" @click="showImg(item)">
        </div>
        <div class="text-1">
          <span>处理结果：{{ one.result }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: "bind",
  data() {
    return {
      one:{},
      list:[],
      modal:false,
    };
  },
  methods: {
    getList(){
      this.fetchData('/user/feedlist',{},res=>{
        if(res.code){
          this.list = res.data
        }
      })
    },
    showImg(url){
      this.$dialog.alert({
        title:false,
        width:'60%',
        showConfirmButton:false,
        closeOnClickOverlay:true,
        message:'<img style="display: block;width: 100%" src="'+url+'"/>'
      })
    }
  },
  created() {
    this.getList()
  }
};
</script>

<style scoped lang="scss">
.root{
  color: #808080;
  height: inherit;
  font-size: 0;
  background: #fff;
  overflow-y: scroll;
  width: 7.5rem;
  overflow-x: hidden;
  .modal-content{
    margin: 0 auto;
    background: #fff;
    padding: .3rem .2rem;
    border-radius: 0;
    color: #000;
    .text-2{
      margin: .16rem 0;
      img{
        display: inline-block;
        width: .74rem;
        height: .74rem;
        vertical-align: middle;
      }
      span{
        vertical-align: middle;
      }
    }
  }
  .list{
    .item{
      width: 5.9rem;
      padding: .2rem .3rem;
      border-radius: .2rem;
      border: 1px solid #ff5d5d;
      margin: .4rem auto;
      position: relative;
      .left{
        .text-1{
          font-size: .3rem;
          color: #ff5d5d;
          margin-bottom: .12rem;
        }
        .text-2{
          color: #000;
          line-height: 1.4;
          font-size: .28rem;
        }
      }
      .right{
        position: absolute;
        right: .3rem;
        top: .3rem;
        color: #0b8fff;
        font-size: .3rem;
      }
    }
  }
  .top{
    width: 8rem;
    margin-left: -.25rem;
    background: #ff5d5d;
    border-bottom-left-radius: 100%;
    border-bottom-right-radius: 100%;
    height: 1.6rem;
    font-size: .34rem;
    color: #fff;
    font-weight: bold;
    text-align: center;
    padding: .8rem 0 0 0;
    letter-spacing: .1rem;
  }
  .icon{
    width: 5.5rem;
    margin: -1rem auto 0;
    padding: .2rem 0;
    background: #fff;
    img{
      display: block;
      width: 1.28rem;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tousujilu.vue